import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function InstantReportAccess() {
  return <section data-section-id="235482" id="begin-your-next-chapter" className="bg-background text-foreground relative flex min-h-[60vh] items-center justify-center overflow-hidden py-24 md:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center opacity-[0.03]">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662596/img/leaving_il_watermark.png" alt="" className="h-auto w-[150%] max-w-none object-contain md:w-[100%] lg:w-[80%]" aria-hidden="true" />
      </div>

      {}
      <div className="container relative z-10 mx-auto flex flex-col items-center gap-10 px-4 text-center">
        <div className="mx-auto max-w-4xl space-y-6">
          <p className="text-muted-foreground text-sm font-default tracking-widest uppercase md:text-base">
            Your journey beyond Illinois starts with a single conversation
          </p>
          <h2 className="font-serif text-foreground text-4xl font-bold leading-tight md:text-5xl lg:text-6xl">
            Ready for Your Next Chapter?
          </h2>
        </div>

        <div className="flex w-full flex-col justify-center gap-6 sm:w-auto sm:flex-row">
          <Button asChild size="lg" className="border-white text-white hover:bg-primary hover:text-primary-foreground hover:border-primary h-16 w-full rounded-sm border-2 bg-transparent px-8 text-lg transition-all duration-300 sm:w-auto font-default">
            <Link to="/HomePage">
              Get Started Call
              <ArrowRight className="ml-2 size-5" />
            </Link>
          </Button>
          
          <Button asChild size="lg" className="border-white text-white hover:bg-primary hover:text-primary-foreground hover:border-primary h-16 w-full rounded-sm border-2 bg-transparent px-8 text-lg transition-all duration-300 sm:w-auto font-default">
            <Link to="/HomePage">
              View Exit Framework
              <ArrowRight className="ml-2 size-5" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}